import React, { Component } from 'react';
import ScrollFadeIn from "./../../components/scrollFadeIn";
import BannerFadeIn from "./../../components/bannerFadeIn";
import CollectionBanner from "./../../components/collectionBanner";
import Footer from './../../components/footer';
import {Helmet} from "react-helmet";

export default class Inspiration extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>{'Kat Medina | Inspiration'}</title>
          <meta name="description" content="Globe trotter. Writer. Entrepreneur. Creative Director. Dog-mom to Donut <3. Seeker and finder of joy." />
        </Helmet>
        <BannerFadeIn>
          <CollectionBanner
            mobileOptimize={true}
            image={'/images/about-hero.jpg'}
            subtitle={'clever ways to get daily inspiration'}
            title={'Daily Ways To Live With Joy'}
          />
        </BannerFadeIn>
        <ScrollFadeIn>
          <div className="large-padding">
            <div className="tiny-padding">
              <h1>{'Kick ass mobile wallpapers'}</h1>
              <p>{'Photos of paint splatters are pretty but a bit pointless... wake up to radness everyday'}</p>
            </div>
            <div className="row">
              <div className="small-12 medium-4 tiny-padding">
                <img className="full-width" src="/images/inspiration-photo1.png" />
                <a className="full-width" href="/images/inspiration-photo1.png" download><div className="button primary-background white full-width">{'Download'}</div></a>
              </div>
              <div className="small-12 medium-4 tiny-padding">
                <img className="full-width" src="/images/inspiration-photo2.png" />
                <a className="full-width" style={{color:"#fff !important"}} href="/images/inspiration-photo2.png" download><div className="button primary-background white full-width">{'Download'}</div></a>
              </div>
              <div className="small-12 medium-4 tiny-padding">
                <img className="full-width" src="/images/inspiration-photo3.png" />
                <a className="full-width" style={{color:"#fff !important"}} href="/images/inspiration-photo3.png" download><div className="button primary-background white full-width">{'Download'}</div></a>
              </div>
            </div>
          </div>
          </ScrollFadeIn>
          <ScrollFadeIn>
            <div className="primary-background section-padding">
              <div className="max-width-container large-padding  centered-text">
                <h1 className="white">{'Live life with openheartedness, the other stuff... ehh throw it away'}</h1>
                <p className="white">{'The Joys of Jetlag'}</p>
              </div>
            </div>
          </ScrollFadeIn>
        <Footer />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/inspiration/index.js